import { styled } from '@mui/material';
import React from 'react';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';

var HeaderContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 20,
            paddingBottom: 20,
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var Title = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        textAlign: 'left',
        fontSize: '24px',
        fontWeight: 'bold',
        lineHeight: '30px',
        color: theme.palette.primary.main,
    });
});
var Paragraph = styled('div')({
    maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
    marginTop: '20px',
    lineHeight: '28px',
    fontSize: '18px',
    textAlign: 'left',
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var EditorialTitleAndParagraph = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.paragraph, paragraph = _c === void 0 ? '' : _c;
    return (React.createElement(HeaderContainer, null,
        title && React.createElement(Title, null, title),
        paragraph &&
            paragraph
                .split('\n')
                .map(function (par, index) { return React.createElement(Paragraph, { key: "etp-".concat(title === null || title === void 0 ? void 0 : title.substring(0, 10), "-").concat(index) }, par); })));
};

export { EditorialTitleAndParagraph };
//# sourceMappingURL=index.js.map
